__turbopack_context__.v({
  "message": "extend-error-message-module-scss-module__L9TGKW__message",
  "section": "extend-error-message-module-scss-module__L9TGKW__section",
  "title": "extend-error-message-module-scss-module__L9TGKW__title",
});
